// UserFilterDialog - MODULE
// ***********************************************************************************************************************
import { Grid, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { TreeCheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/framework/base";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { DrawerContent } from "../../framework/Drawer/DrawerContent";
import { FilterButtons } from "../../framework/Filters/FilterButtons";
import { FilterSearchField } from "../../framework/Filters/FilterSearchField";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { PageFilterConditionDrawer } from "../../framework/Page/PageFilterConditionDrawer";

//UserFilterDialog
export interface IUserFilterDrawerProp {
    open: boolean;
    classes?: string;
    filter: IListFilterItem;
    userGroups: IIdTitleNode[];
    activityFilters: IIdTitle[];
    selectedUserGroupIds: string[];
    selectedActivityFilterId: string;
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, selectedActivityFilterId: string, selectedUserGroupIds: string[]) => any;
    onCancel: () => void;
}

export interface IUserFilterDrawerState {
    selectedUserGroupIds: string[];
    selectedActivityFilterId: string;
}

export class UserFilterDrawer extends React.Component<IUserFilterDrawerProp, IUserFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IUserFilterDrawerProp): IUserFilterDrawerState => {
        return {
            selectedActivityFilterId: props.selectedActivityFilterId,
            selectedUserGroupIds: props.selectedUserGroupIds.slice(0)
        };
    };

    constructor(props: IUserFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IUserFilterDrawerProp, prevState: IUserFilterDrawerState): void {
        const props = this.props;
        if (!prevProps || prevProps?.filter?.getHash() === props?.filter?.getHash()) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "activityFilterId") {
            this.setState({ selectedActivityFilterId: value });
        }
    };

    handleChangeUserGroupIds = (selectedUserGroupIds: string[]) => {
        this.setState({
            selectedUserGroupIds
        });
    };

    getSaveDataFromState = (props: IUserFilterDrawerProp, state: IUserFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedActivityFilterId", state.selectedActivityFilterId ? state.selectedActivityFilterId : null);
        result.append("selectedUserGroupIds", JSON.stringify(state.selectedUserGroupIds));
        return result;
    };
    
    static filterIsSet = (activityFilters: IIdTitle[], userGroups: IIdTitleNode[],
        selectedActivityFilterId: string, selectedUserGroupIds: string[]): boolean => {
        if (userGroups.length < 1) return false;
        return !(selectedActivityFilterId === activityFilters[0].id &&
            Base.equalStrArrays(selectedUserGroupIds, [userGroups[0].id]));
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state.selectedActivityFilterId, state.selectedUserGroupIds);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state.selectedActivityFilterId, state.selectedUserGroupIds);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        this.setState({
            selectedActivityFilterId: props.activityFilters[0].id,
            selectedUserGroupIds: [props.userGroups[0].id]
        });
    };

    handleSave = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.selectedActivityFilterId, state.selectedUserGroupIds);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            <FilterSearchField
                                filter={props.filter}
                                canRemoveSharedFilters={props.canRemoveSharedFilters}
                                onSaveFilter={this.handleSaveFilter}
                                onRemoveFilter={props.onRemoveFilter}
                            />
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Users}>
                                        <Select
                                            name="activityFilterId"
                                            title={Translations.Users}
                                            value={state.selectedActivityFilterId}
                                            onChange={this.handleChange}
                                        >
                                            {props.activityFilters.map((activityFilter) => (
                                                <MenuItem
                                                    key={activityFilter.id}
                                                    value={activityFilter.id}
                                                >
                                                    {activityFilter.title}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.UserGroups}>
                                        <TreeCheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedUserGroupIds}
                                            values={props.userGroups}
                                            onChange={this.handleChangeUserGroupIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons
                            onSave={this.handleSave}
                            onCancel={() => this.handleCancel(false)}
                            onClear={this.handleClear}
                        />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}